import template from './stDisabledOverlay.template.html';

export default {
  template,
controller: class controller {
    constructor() {
      'ngInject';

    }
  }
};
